import { Button, Flex, Stack, Text } from '@mantine/core'

import { Icons } from 'src/common/components'

import useDeleteEscalation from '../../hooks/useDeleteEscalation.hook'

const DeleteEscalationContent = ({
  escalationId,
}: {
  escalationId: string
  onMutationSuccess: () => void
}) => {
  const { deleteEscalation, deleteMutationStatus } = useDeleteEscalation()

  const handleDelete = async () => {
    deleteEscalation(escalationId)
  }

  return (
    <>
      <Stack align="center" justify="center" gap="md">
        <Icons.Warning
          width="60"
          height="60"
          color="var(--mantine-color-red-6)"
        />
        <Text
          size={'16px'}
          fw={700}
          style={{ color: 'var(--mantine-color-red-6)' }}
        >
          Confirm Escalation Removal
        </Text>
        <Text ta="center" mb={5} c="var(--mantine-color-red-9)">
          That action will also delete all the associated information including
          notes and attachments.
        </Text>
      </Stack>
      <Flex justify="center" align="flex-start" mt="lg">
        <Button
          color="var(--mantine-color-red-6)"
          loading={deleteMutationStatus === 'pending'}
          type="submit"
          variant="filled"
          onClick={handleDelete}
        >
          Delete Escalation
        </Button>
      </Flex>
    </>
  )
}
export default DeleteEscalationContent
